export const states = {
  PORTFOLIO_CHANGED: 'PORTFOLIO_CHANGED',
  PORTFOLIO_INCORRECT: 'PORTFOLIO_INCORRECT',
  PORTFOLIO_NOT_CHANGED: 'PORTFOLIO_NOT_CHANGED',

  PORTFOLIO_SWITCHED: 'PORTFOLIO_SWITCHED',
  PORTFOLIO_NOT_SWITCHED: 'PORTFOLIO_NOT_SWITCHED',
  PORTFOLIO_RISK_ATTENTION: 'PORTFOLIO_RISK_ATTENTION',
}
